export const FIEL_TAG_EVENTS = {
  OPEN_FIEL_MODAL: 'FielModalOpened',
  SKIP_FIEL_SIGNATURE: 'FielSignatureSkipped',
  SUCCESS_FIEL_SIGNATURE: 'FielSignatureSuccess',
  FAILED_FIEL_SIGNATURE: 'FielSignatureFailed',
};
